import request from '@/utils/request'
export default {
    // 发送验证码
    getPhoneToken(data) {
        return request({
            url: `/v1/send_sms_code.do`,
            method: 'post',
            data: data
        })
    },
    // 登录
    login(data) {
        return request({
            url: `/v1/login.do`,
            method: 'post',
            data: data
        })
    },
    // 二维码支付 
    pay(data) {
        return request({
            url: `/api/order_pay.do`,
            method: 'post',
            data: data
        })
    },
    // 获取模型分类
    getModelClassify(data) {
        return request({
            url: `/v1/model/types`,
            method: 'post',
            data: data
        })
    },
    // 获取模型信息 v1/model/info 
    getModelInfo(data) {
        return request({
            url: `v1/model/info`,
            method: 'post',
            data: data
        })
    },
    // 获取层级数据 v1/model/groups 
    getModellev(data) {
        return request({
            url: `v1/model/groups`,
            method: 'post',
            data: data
        })
    },
    // 相关视频（视频、治疗、疾病） v1/model/videos 
    getAboutVid(data) {
        return request({
            url: `v1/model/videos`,
            method: 'post',
            data: data
        })
    },
    // 影像图谱 /v1/anatomy_image/category
    getCategory(data) {
        return request({
            url: `/v1/anatomy_image/category`,
            method: 'post',
            data: data
        })
    },
    // 影像图谱详情 /v1/anatomy_image/info
    getCategoryInfo(data) {
        return request({
            url: `/v1/anatomy_image/info`,
            method: 'post',
            data: data
        })
    },
    // 相关病症 v1/model/disease_list
    getDisease(data) {
        return request({
            url: `/v1/model/disease_list`,
            method: 'post',
            data: data
        })
    },
    // 相关模型 v1/model/relevant_model
    getMicroanatomy(data) {
        return request({
            url: `v1/model/relevant_model`,
            method: 'post',
            data: data
        })
    },
    // 获取全部模型信息 v1/model/all_model
    getAllModel(data) {
        return request({
            url: `v1/model/all_model`,
            method: 'post',
            data: data
        })
    },
    // 用户信息 /v1/user_info
    getUserInfo(data) {
        return request({
            url: `/v1/user_info`,
            method: 'post',
            data: data
        })
    },
    // 收藏列表 /v1/collect/list
    getCollect(data) {
        return request({
            url: `/v1/collect/list`,
            method: 'post',
            data: data
        })
    },
    // 添加收藏 /v1/collect/pc_save
    setCollect(data) {
        return request({
            url: `/v1/collect/pc_save`,
            method: 'post',
            data: data
        })
    },
    // 收藏详情 /v1/collect/detail 
    getColDetail(data) {
        return request({
            url: `/v1/collect/detail`,
            method: 'post',
            data: data
        })
    },
    // vip 套餐 /v1/vip_package_list
    getVipList(data) {
        return request({
            url: `/v1/vip_package_list`,
            method: 'post',
            data: data
        })
    },
    // 获取微信支付二维码 /v1/order_pay.do 
    getVipCode(data) {
        return request({
            url: `/v1/order_pay.do`,
            method: 'post',
            data: data
        })
    },
    // 获取支付结果 v1/order/info
    getPayResult(data) {
        return request({
            url: `v1/order/info`,
            method: 'post',
            data: data
        })
    },
    // 广告监测数据初始化 /v1/bdpageAdMonitorInit.do
    initBpage(data) {
        return request({
            url: `/v1/bdpageAdMonitorInit.do`,
            method: 'post',
            data: data
        })
    },
    // 骨性标志列表 v1/model/boneMarksList
    getBoneList(data) {
        return request({
            url: `/v1/model/boneMarksList`,
            method: 'post',
            data: data
        })
    },
    // 肌肉运动分类 v1/model/muscleAnimationsCategoryList 
    getCategoryList(data) {
        return request({
            url: `/v1/model/muscleAnimationsCategoryList`,
            method: 'post',
            data: data
        })
    },
    // 获取肌肉列表 v1/model/muscleAnimationsList
    getAnimationsList(data) {
        return request({
            url: `/v1/model/muscleAnimationsList`,
            method: 'post',
            data: data
        })
    },
}